export default {
    bind(el) {
        if(el.href === undefined){
            return console.warn('No href on the element with v-add-active')
        }

        if(el.href !== location.href){
            return;
        }

        el.classList.add('active');
    },
  };
  